import React from "react";
import { CheckCircle, ArrowUp, Layers } from "lucide-react";

const Plans = () => {
  return (
    <section className="mx-auto bg-greyish px-8 py-12">
      {/* Main Heading */}
      <div className="mx-auto pb-10 max-w-90vw p-3 md:p-0">
        <div className="text-left mb-10 max-w-[620px]">
          <h1 className="text-4xl sm:text-5xl font-bold leading-7 font-sans mb-6">
            <span className="text-green-600 tracking-wide">SurveysIQ </span> at
            a Glance
          </h1>
          <p className="text-xl mt-8">
            SurveysIQ is a platform where your opinions turn into rewards.
          </p>
          <p className="text-[20px] leading-7 font-sans mt-2">
            Unlike traditional survey apps, we offer real earning potential with
            structured plans to help you scale your rewards.
          </p>
        </div>

        <div className="border-t border-gray-200 my-8"></div>

        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              Icon: CheckCircle,
              title: "Trusted by 10K+ users",
              desc: "Join our growing community of survey takers earning rewards every day.",
            },
            {
              Icon: ArrowUp,
              title: "Instant reward system",
              desc: "Get paid immediately after completing surveys. No waiting periods.",
            },
            {
              Icon: Layers,
              title: "Transparent earnings",
              desc: "Clear reward structure with detailed tracking of your earnings.",
            },
          ].map((card, i) => (
            <div
              key={i}
              className="group bg-white p-6 rounded-lg shadow-sm hover:shadow-xl hover:bg-green-500 transition-all duration-300 transform hover:-translate-y-1 cursor-pointer"
            >
              <card.Icon
                className="text-green-600 group-hover:text-white mb-3 bg-green-100 group-hover:bg-green-600 p-1 rounded transition-all duration-300 transform group-hover:scale-110"
                size={40}
              />
              <h3 className="text-xl font-semibold font-sans text-gray-800 group-hover:text-white mb-3 transition-colors duration-300">
                {card.title}
              </h3>
              <p className="text-gray-600 group-hover:text-white transition-colors duration-300">
                {card.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Plans;
